import { useState } from "react";

const GithubRepoSelector = ({githubRepos, handleSelectedRepos}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedRepos, setSelectedRepos] = useState([]);

  // Filtered list based on search term
  const filteredRepos = githubRepos.filter((repo) =>
    repo.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Handle checkbox selection
  const handleSelect = (repo) => {
    setSelectedRepos((prevSelected) =>
      prevSelected.includes(repo)
        ? prevSelected.filter((repo_name) => repo_name !== repo)
        : [...prevSelected, repo]
    );
  };

  // Handle form submission
  const handleSubmit = () => {
    handleSelectedRepos(selectedRepos);
  };

  return (
    <div style={{padding: '24px'}}>
      <h2>Select GitHub Repositories</h2>
      <input
        type="text"
        placeholder="Search repositories..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <ul style={{maxHeight: '200px', overflowY: 'auto', padding: '24px'}}>
        {filteredRepos.map((repo) => (
          <li key={repo} style={{padding: '8px'}}>
            <label>
              <input
                type="checkbox"
                checked={selectedRepos.includes(repo)}
                onChange={() => handleSelect(repo)}
                style={{marginRight: '8px', verticalAlign: 'middle'}}
              />
              {repo}
            </label>
          </li>
        ))}
      </ul>
      <button onClick={handleSubmit}>Submit</button>
    </div>
  );
};

export default GithubRepoSelector;
